import React from 'react';
import PropTypes from 'prop-types';

const CheckSquareBroken = ({color = 'currentColor', ...props}) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.875 2.5H5.3125C3.7592 2.5 2.5 3.75919 2.5 5.31248V14.6875C2.5 16.2408 3.7592 17.5 5.3125 17.5H14.6875C16.2408 17.5 17.5 16.2408 17.5 14.6875V9.53121M16.5625 4.84374L10 11.4062L8.125 9.53121"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CheckSquareBroken.propTypes = {
  color: PropTypes.string,
};

export default CheckSquareBroken;
